import { render, staticRenderFns } from "./ShippingRequireConfirmationCheckbox.vue?vue&type=template&id=1d8d7e0e"
import script from "./ShippingRequireConfirmationCheckbox.vue?vue&type=script&lang=js"
export * from "./ShippingRequireConfirmationCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports